



/*----------------------------------------------------------
    IE
----------------------------------------------------------*/
if(navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
  $('body').on("mousewheel", function () {
    event.preventDefault();
    var wd = event.wheelDelta;
    var csp = window.pageYOffset;
    window.scrollTo(0, csp - wd);
});
}
/*----------------------------------------------------------
  loading
----------------------------------------------------------*/
var LoadEnd=false;
jQuery.event.add(window,"load",function() {
  var target=$("#loading");
  
  if(location.hash){
    $('html,body').stop().animate({ scrollTop:$(location.hash).offset().top-270},800, 'easeInOutExpo');
}

  if($(".block_mainvisual .slide_area .column").length){
    if(!viewTop){
      setTimeout(function(){
        $("#top_logo").addClass('view');
      },500);
      setTimeout(function(){
        LoadEnd=true;
        $("#top_logo").addClass('out');
        target.addClass('out');
        //スクロール表示
        ScrollView_func();
        setTimeout(function(){
          target.hide();
          ScrollView_func()
          $("body").addClass('pageLoad');
        },1000);
        

        if(WinW>896){
          if($("body").hasClass("set_announcement")){
            $('.block_mainvisual .slide_area').height(WinH-38);
            $('.block_mainvisual .slide_area .column').height(WinH-38);
          }else{
            $('.block_mainvisual .slide_area').height(WinH);
            $('.block_mainvisual .slide_area .column').height(WinH);
          }
        }else{
          $('.block_mainvisual .slide_area').css("height","144vw");
          $('.block_mainvisual .slide_area .column').css("height","144vw");
        }
        $('.block_mainvisual .slide_area').slick({
            accessibility: false,
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 1500, 
          pauseOnHover: false, 
          pauseOnDotsHover: false,
          cssEase: 'ease', 
          dots: true,
          draggable: true,
          fade: true,
          arrows: false,
          infinite: true,
          initialSlide: 0,
          lazyLoad: 'ondemand',
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          vertical: false,
          centerMode: true,
          variableWidth: false,
          centerPadding: 0
        }).on('reInit init', function(event, slick, currentSlide, nextSlide){
            //console.log("reInit init : "+currentSlide);
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            //console.log("beforeChange : "+currentSlide);
            $('.block_mainvisual .slide_area .column').eq(nextSlide).addClass('slick-continue');
        }).on('afterChange', function(event, slick, currentSlide, nextSlide){
            var i = (currentSlide ? currentSlide : 0) + 1;
            $('.block_mainvisual .slide_area .column:not(:eq('+currentSlide+'))').removeClass('slick-continue');
        })
        $('.block_mainvisual .slide_area .column').eq(0).addClass('slick-continue');
      },2000);
    
    }else{
      LoadEnd=true;
      $("body").addClass('pageLoad');
      
      if(WinW>896){
        if($("body").hasClass("set_announcement")){
          $('.block_mainvisual .slide_area').height(WinH-38);
          $('.block_mainvisual .slide_area .column').height(WinH-38);
        }else{
          $('.block_mainvisual .slide_area').height(WinH);
          $('.block_mainvisual .slide_area .column').height(WinH);
        }
      }else{
        $('.block_mainvisual .slide_area').css("height","144vw");
        $('.block_mainvisual .slide_area .column').css("height","144vw");
      }
      $('.block_mainvisual .slide_area').slick({
          accessibility: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1500, 
        pauseOnHover: false, 
        pauseOnDotsHover: false,
        cssEase: 'ease', 
        dots: true,
        draggable: true,
        fade: true,
        arrows: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        vertical: false,
        centerMode: true,
        variableWidth: false,
        centerPadding: 0
      }).on('reInit init', function(event, slick, currentSlide, nextSlide){
          //console.log("reInit init : "+currentSlide);
      }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
          //console.log("beforeChange : "+currentSlide);
          $('.block_mainvisual .slide_area .column').eq(nextSlide).addClass('slick-continue');
      }).on('afterChange', function(event, slick, currentSlide, nextSlide){
          var i = (currentSlide ? currentSlide : 0) + 1;
          $('.block_mainvisual .slide_area .column:not(:eq('+currentSlide+'))').removeClass('slick-continue');
      })
      $('.block_mainvisual .slide_area .column').eq(0).addClass('slick-continue');

    }


}else{
  LoadEnd=true;
  $("#top_logo").addClass('out');
  target.addClass('out');
  //スクロール表示
  ScrollView_func();
  setTimeout(function(){
    target.hide();
    ScrollView_func()
    $("body").addClass('pageLoad');
  },1000);
}
  
});
/*----------------------------------------------------------
init
----------------------------------------------------------*/
var WinScroll = 0;
var WinW = 0;
var WinH = 0;
var delayScroll=0;
var viewTop="";
(function() {
  $("body").addClass("loadStart");

  //告知バー
  if($(".announcement-bar").length){
    $("body").addClass("set_announcement");
  }
  
  /*言語判別
  ----------------------------------------------------------*/
  var viewTop = $.cookie('nanatural');
  console.log("viewTop:"+viewTop);
  if($("#top_logo").length){
    if(viewTop){
      $("#loading").remove();
      $("#top_logo").remove();
      $("body").addClass('fast_view');
    }else{
      $.cookie('nanatural','yes');
    }
    $("#footer .copyright").on("click", function (e) {
        e.preventDefault();
        $.removeCookie('nanatural');
    });
  }



function init(){
  WinScroll = $(window).scrollTop();
  WinW = $(window).width();
  WinH = window.innerHeight ? window.innerHeight : $(window).height();
  

  /*scroll
  ----------------------------------------------------------*/
  $(".page_top").on("click", function (e) {
    e.preventDefault();
  $('html,body').stop().animate({ scrollTop:0},800, 'easeInOutExpo');
});

  /*ヘッダー
  ----------------------------------------------------------*/
  $('.block_navi a').on("click", function (e) {
    e.preventDefault();
    if($("body").hasClass("menu_open")){
      $("body").removeClass("menu_open");
      $("body").css("overflow","auto");
    }else{
      $("body").addClass("menu_open");
      $("body").css("overflow","hidden");
    }
  });
  
  if(WinW>896){
    $('.nana_block_header ul.menu > li.pullover').hover(function() {
      $("body").addClass("header_move_hight");
    }, function() {
      $("body").removeClass("header_move_hight");
    });
  }

  /*header
  ----------------------------------------------------------*/
  $(".block_header ul.menu > li > a,.block_sp_menu ul.menu > li > a").on("click", function (e) {
    if($("body").hasClass("top")){
      var target=$(this).attr("target-scroll");
      if(target!="#"){
        e.preventDefault();
        $("body").removeClass("menu_open");
        $("body").css("overflow","auto");
        $('html,body').stop().animate({ scrollTop:$(target).offset().top-120},800, 'easeInOutExpo');
      }
    }
  });

  
  /*scroll
  ----------------------------------------------------------*/
  if($(".block_stories .inner .slide_area").length){
      var contentcopy=$(".block_stories .inner .slide_area .list .column");
      contentcopy.clone().appendTo(".block_stories .inner .slide_area .list");
    $('.block_stories .inner .list').slick({
      accessibility: false,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 800, 
      pauseOnHover: false, 
      pauseOnDotsHover: false,
      cssEase: 'ease', 
      dots: false,
      draggable: true,
      fade: false,
      arrows: false,
      infinite: true,
      initialSlide: 0,
      lazyLoad: 'ondemand',
      slidesToShow: 3,
      slidesToScroll: 1,
      swipe: true,
      vertical: false,
      centerMode: false,
      variableWidth: true,
      centerPadding: 0
    }).on('reInit init', function(event, slick, currentSlide, nextSlide){
        //console.log("reInit init : "+currentSlide);
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        //console.log("beforeChange : "+currentSlide);
        // $('.block_mainvisual .slide_area .column').eq(nextSlide).addClass('slick-continue');
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
        // $('.block_mainvisual .slide_area .column:not(:eq('+currentSlide+'))').removeClass('slick-continue');
    })
  }
  // if($(".block_stories .inner .slide_area").length){
  //   if(WinW>896){
  //     var deg=$(".block_stories .inner .slide_area .list .column").length*26.56;
  //   }else{
  //     var deg=$(".block_stories .inner .slide_area .list .column").length*64.1;
  //   }
  //   $(".block_stories .inner .slide_area .list").css("width",deg+"vw");
  //   var slide_max=$(".block_stories .inner .slide_area .list").width();
  //   $(".block_stories .inner .slide_area").css("width",deg*3+"vw");
  //   var contentcopy=$(".block_stories .inner .slide_area .list");
  //   contentcopy.clone().appendTo(".block_stories .inner .slide_area");
  //   contentcopy.clone().appendTo(".block_stories .inner .slide_area");

  //   var target_x=0;
  //   setInterval(function(){
  //     // console.log(target_x)
  //     // target_x=target_x-10;
  //     if(target_x>-parseInt(slide_max)){
  //       if(WinW>896){
  //         target_x=target_x-0.5;
  //       }else{
  //         target_x=target_x-1;
  //       }
  //     }else{
  //       target_x=0;
  //     }
  //     $(".block_stories .inner .slide_area").css(cssTransformImage(target_x,0));
  //   },10);
  // }
  /*accordion
  ----------------------------------------------------------*/
  $('.block_detail .wrap .text_area .inner .entry dl.accordion').each(function(index) {
    $(this).find("dt").on("click", function (e) {
      e.preventDefault();
      if($(this).parent().hasClass("view")){
        $(this).parent().removeClass("view");
        // $(this).parent().find("dd").slideUp(500);
        $(this).parent().find("dd").hide();
        scroll_resize();
      }else{
        $(this).parent().addClass("view");
        // $(this).parent().find("dd").slideDown(500);
        $(this).parent().find("dd").show();
        scroll_resize();
      }
    });
  });
  

  if($(".block_detail .wrap .image_area").length&&WinW<=896){
    $('.block_detail .wrap .image_area ul').slick({
        accessibility: false,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 500, 
      pauseOnHover: false, 
      pauseOnDotsHover: false,
      cssEase: 'ease', 
      dots: true,
      draggable: true,
      fade: false,
      arrows: false,
      infinite: true,
      initialSlide: 0,
      lazyLoad: 'ondemand',
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      vertical: false,
      centerMode: true,
      variableWidth: false,
      centerPadding: 0
    }).on('reInit init', function(event, slick, currentSlide, nextSlide){
        //console.log("reInit init : "+currentSlide);
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        //console.log("beforeChange : "+currentSlide);
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        var i = (currentSlide ? currentSlide : 0) + 1;
    })
  }

  //スマホのトップカラム削除
  if($(".block_product .list .column.non_column").length&&WinW<=896){
    $(".block_product .list .column.non_column").remove();
  }
  
  /*FAQ
  ----------------------------------------------------------*/
  $('.block_text .in_area .c_area .ac_area dl').each(function(index) {
    $(this).find("dt").on("click", function (e) {
      e.preventDefault();
      if($(this).parent().hasClass("view")){
        $(this).parent().removeClass("view");
        // $(this).parent().find("dd").slideUp(500);
        $(this).parent().find("dd").hide();
        scroll_resize();
      }else{
        $(this).parent().addClass("view");
        // $(this).parent().find("dd").slideDown(500);
        $(this).parent().find("dd").show();
        scroll_resize();
      }
    });
  });
  /*contact
  ----------------------------------------------------------*/
    // $(".block_text .in_area .change ul li a").on("click", function (e) {
    //   e.preventDefault();
    //   $(".block_text .in_area .change ul li a").removeClass("active");
    //   $(this).addClass("active");
    //   var target=$(this).attr("href");
    //   $(".block_text .in_area .c_area").hide();
    //   $(target).show();
    // });
    $(".block_text .in_area .change ul li a").on("click", function (e) {
      e.preventDefault();
      // $(".block_text .in_area .change ul li a").removeClass("active");
      // $(this).addClass("active");
      var target=$(this).attr("href");
      if(WinW>896){
      $('html,body').stop().animate({ scrollTop:$(target).offset().top-270},800, 'easeInOutExpo');
      }else{
      $('html,body').stop().animate({ scrollTop:$(target).offset().top-200},800, 'easeInOutExpo');

      }
    });

    if($("#checkout").length){
    $('#checkout').prop("disabled", true); 
    $('#optin').change(function() {
          if ($(this).prop("checked")) {
              $('#checkout').prop("disabled", false);
          } else {
              $('#checkout').prop("disabled", true);
          }
      });
    }
  
}//end :init


/*----------------------------------------------------------
  scroll
----------------------------------------------------------*/
var past_scroll=0;
function scroll_resize(){
    WinScroll = $(window).scrollTop();
    WinW = $(window).width();
    WinH = window.innerHeight ? window.innerHeight : $(window).height();
    ScrollView_func();
  
  /*scroll
  ----------------------------------------------------------*/
  if(WinScroll>100){
      $("body").addClass("onScroll");
  }else{
      $("body").removeClass("onScroll");
  }
  /*header
  ----------------------------------------------------------*/
  if(WinScroll<past_scroll){
      if($("body").hasClass("onScroll")){
        $("body").addClass("headerView");
    }else{
        $("body").removeClass("headerView");
    }
  }else{
      $("body").removeClass("headerView");
  }
  
  /*mainvisual
  ----------------------------------------------------------*/
  if(WinW>896){
    if($("body").hasClass("set_announcement")){
      $('.block_mainvisual .slide_area').height(WinH-38);
      $('.block_mainvisual .slide_area .column').height(WinH-38);
    }else{
      $('.block_mainvisual .slide_area').height(WinH);
      $('.block_mainvisual .slide_area .column').height(WinH);
    }
  }
  
  /*Contact 固定
  ----------------------------------------------------------*/
  if($(".block_text .in_area .change").length){
    if(WinW>896){
      var target_end_y=($(".block_text .in_area").offset().top-140);
      if(WinScroll<=target_end_y){
        $(".block_text .in_area .change").css({"position":"absolute","top":-60});
      }else if(WinScroll>target_end_y){
        $(".block_text .in_area .change").css({"position":"fixed","top":80,"width":640,"left":"50%","margin-left":-320});
      }
    }else{
      var target_end_y=($(".block_text .in_area").offset().top-80);
      if(WinScroll<=target_end_y){
        $(".block_text .in_area .change").css({"position":"absolute","top":-30});
      }else if(WinScroll>target_end_y){
        $(".block_text .in_area .change").css({"position":"fixed","top":50,"width":"100%","left":"0%","margin-left":-0});
      }
    }
    if(WinScroll>=0&&WinScroll<=$("#faq").offset().top-360){
      $(".block_text .in_area .change ul li:nth-child(1) a").addClass("active");
      $(".block_text .in_area .change ul li:nth-child(2) a").removeClass("active");
    }else{
      $(".block_text .in_area .change ul li:nth-child(1) a").removeClass("active");
      $(".block_text .in_area .change ul li:nth-child(2) a").addClass("active");
    }
  }

  
  //サイドメニューFIX制御
  if(WinW>896){
    if($(".block_detail .wrap .text_area .text_area_wrap").length){

      var target_end_y=($("#product").offset().top-WinH)-($(".block_detail .wrap .text_area .text_area_wrap").height()-WinH+260);

      if($("#detail .image_area").height() > $("#detail .text_area_wrap").height()){
        if(WinScroll<=target_end_y){
          $(".block_detail .wrap .text_area .text_area_wrap").css({"position":"fixed","top":80});
        }else if(WinScroll>target_end_y){
          // console.log("f");
          // var target_top=$("#detail").height()-WinH;
          var target_top=$("#detail").height()-$(".block_detail .wrap .text_area .text_area_wrap").height()+260;
          $(".block_detail .wrap .text_area .text_area_wrap").css({"position":"absolute","top":target_top-260});
        }
      }else{
        $(".block_detail .wrap .text_area .text_area_wrap").css({"position":"relative","top":0});
      }
    }
  }

  past_scroll=WinScroll;
}
$(window).on('load', init);
$(window).on('orientationchange load scroll resize', scroll_resize);
})();

//scroll
function ScrollView_func(){
$('.scrollview').each(function(index) {
    if(LoadEnd&&WinScroll>$(this).offset().top-WinH*0.9){
      $(this).addClass("view");
  }else{
      $(this).removeClass("view");
  }
});
$('.scrollview_fix').each(function(index) {
    if(LoadEnd&&WinScroll>$(this).offset().top-WinH*0.9){
      $(this).addClass("view");
  }else{
      $(this).removeClass("view");
  }
});
}
/*----------------------------------------------------------
transform
----------------------------------------------------------*/
function cssTransition(duration,delay,easing){
  var css = duration +'s '+ delay +'s '+easing;
return {
    "-webkit-transition" : css,
  "-moz-transition"    : css,
  "-o-transition"      : css,
  "-ms-transition"     : css,
  "transition"         : css
}
}
function cssTransformImage(x,y){
  var css = "translate3d("+x+"px,"+y+"px,0px) rotate(-0deg)";
return {
    "-webkit-transform" : css,
  "-moz-transform"    : css,
  "-o-transform"      : css,
  "-ms-transform"     : css,
  "transform"         : css
}
}
function cssTransformImageR(x,y,rotation){
  var css = "translate3d("+x+"px,"+y+"px,0px) rotate("+rotation+"deg)";
return {
    "-webkit-transform" : css,
  "-moz-transform"    : css,
  "-o-transform"      : css,
  "-ms-transform"     : css,
  "transform"         : css
}
}
function cssTransformRotation(Rotation){
  var css = "rotate("+Rotation+"deg)";
return {
    "-webkit-transform" : css,
  "-moz-transform"    : css,
  "-o-transform"      : css,
  "-ms-transform"     : css,
  "transform"         : css
}
}
function cssTransformscale(scale){
  var css = "scale3d("+scale+","+scale+","+scale+")";
return {
    "-webkit-transform" : css,
  "-moz-transform"    : css,
  "-o-transform"      : css,
  "-ms-transform"     : css,
  "transform"         : css
}
}
function cssTransform(x,y){
  var css = "scale3d(1.2,1.2,1.2) translate3d("+x+"px,"+y+"px,0px) rotate(-0deg)";
return {
    "-webkit-transform" : css,
  "-moz-transform"    : css,
  "-o-transform"      : css,
  "-ms-transform"     : css,
  "transform"         : css
}
}